/* eslint-disable react-hooks/exhaustive-deps */
import { Link } from "react-router-dom";
import React, { useEffect } from "react";
import { HiOutlineDocument } from "react-icons/hi";
import { VscFileSubmodule } from "react-icons/vsc";
import { BsBook, BsPeople } from "react-icons/bs";
import { GrAttraction, GrRestaurant } from "react-icons/gr";
import {
  MdMusicNote,
  MdOutlineMuseum,
  MdOutlineFoodBank,
  MdOutlineNightlight,
  MdOutlineHotelClass,
  MdOutlineFormatPaint,
  MdOutlineMapsHomeWork,
} from "react-icons/md";
import { SiHotelsdotcom } from "react-icons/si";
import { AiOutlineShopping } from "react-icons/ai";
import { BiCameraMovie } from "react-icons/bi";
import { GiTheater, GiBallerinaShoes } from "react-icons/gi";
import { Card, GoBack, DashboardIntro } from "../../component/Component";
import { useStaticContext } from "../../../../context/static/StaticContext";
import { useAdminContext } from "../../../../context/admin/context/AdminContext";
import { getOneCompany } from "../../../../middlewares/sysNavigation/SysNavigation";
import { _TYPES_ } from "../../../doseeData/utils/types";

const Icon = [
  <VscFileSubmodule />,
  <GrAttraction />,
  <GrRestaurant />,
  <MdOutlineHotelClass />,
  <MdMusicNote />,
  <BsBook />,
  <MdOutlineMuseum />,
  <GrAttraction />,
  <BiCameraMovie />,
  <MdOutlineMuseum />,
  <MdOutlineNightlight />,
  <SiHotelsdotcom />,
  <MdOutlineHotelClass />,
  <AiOutlineShopping />,
  <MdOutlineFoodBank />,
  <BsBook />,
  <BsPeople />,
  <MdOutlineFormatPaint />,
  <GiBallerinaShoes />,
  <GiTheater />,
  <GrAttraction />,
  <BsBook />,
  <HiOutlineDocument />,
  <BsBook />,
  <MdOutlineMapsHomeWork />,
  <GiTheater />,
  <MdOutlineMapsHomeWork />,
];

const companiesRoute = "/company";

const CompanyDash = () => {
  const { setSingleAdmin } = useAdminContext();
  const { stats, getCompanyStats } = useStaticContext();
  const company = getOneCompany();
  const company_name = company?.name;
  const company_owner = company?.owner_id;

  useEffect(() => {
    if (!stats) {
      getCompanyStats({ data: { ids: [company_owner] } });
    }
  }, [stats]);

  const List = [
    { name: "events", quantity: stats ? stats?.event : "-", route: "/data/event", type: _TYPES_.EVENT },
    { name: "attractions", quantity: stats ? stats?.attraction : "-", route: "/data/attraction", type: _TYPES_.ATTRACTION },
    { name: "restaurants", quantity: stats ? stats?.restaurant : "-", route: "/data/restaurant", type: _TYPES_.RESTAURANT },
    { name: "best of africa", quantity: stats ? stats?.best_of_africa : "-", route: "/data/bestofafrica", type: _TYPES_.BESTOFAFRICA },
    { name: "music", quantity: stats ? stats?.music : "-", route: "/data/music", type: _TYPES_.MUSIC },
    { name: "news", quantity: stats ? stats?.news : "-", route: "/data/news", type: _TYPES_.NEWS },
    { name: "safaris", quantity: stats ? stats?.safari : "-", route: "/data/safari", type: _TYPES_.SAFARI },
    { name: "tour packages", quantity: stats ? stats?.tour_package : "-", route: "/data/tour/package", type: _TYPES_.TOURPACKAGE },
    { name: "cinema", quantity: stats ? stats?.cinema : "-", route: "/data/cinema", type: _TYPES_.CINEMA },
    { name: "museums", quantity: stats ? stats?.museum : "-", route: "/data/museum", type: _TYPES_.MUSEUM },
    { name: "night life", quantity: stats ? stats?.nightlife : "-", route: "/data/nightlife", type: _TYPES_.NIGHTLIFE },
    { name: "hotels", quantity: stats ? stats?.hotel : "-", route: "/data/hotel", type: _TYPES_.HOTEL },
    { name: "classes", quantity: stats ? stats?.class : "-", route: "/data/class", type: _TYPES_.CLASSES },
    { name: "shopping", quantity: stats ? stats?.shopping : "-", route: "/data/shopping", type: _TYPES_.SHOPPING },
    { name: "food", quantity: stats ? stats?.food : "-", route: "/data/food", type: _TYPES_.FOOD },
    { name: "books", quantity: stats ? stats?.book : "-", route: "/data/book", type: _TYPES_.BOOK },
    { name: "neighborhoods", quantity: stats ? stats?.neighborhood : "-", route: "/data/neighborhood", type: _TYPES_.NEIGHBORHOOD },
    { name: "arts", quantity: stats ? stats?.art : "-", route: "/data/art", type: _TYPES_.ART },
    { name: "dance", quantity: stats ? stats?.dance : "-", route: "/data/dance", type: _TYPES_.DANCE },
    { name: "theaters", quantity: stats ? stats?.theater : "-", route: "/data/theater", type: _TYPES_.THEATER },
    { name: "City Guides", quantity: stats ? stats?.city_guide : "-", route: "/data/city/guide", type: _TYPES_.CITYGUIDE },
    { name: "Parties", quantity: stats ? stats?.party : "-", route: "/data/party", type: _TYPES_.PARTY },
    { name: "Things To Do", quantity: stats ? stats?.things_to_do : "-", route: "/data/things/todo", type: _TYPES_.THINGSTODO },
    { name: "Tips And Advice", quantity: stats ? stats?.tips_and_advice : "-", route: "/data/tips/advice", type: _TYPES_.TIPSANDADVICE },
    { name: "Ministries", quantity: stats ? stats?.ministry : "-", route: "/data/ministry", type: _TYPES_.MINISTRY },
    { name: "Movies", quantity: stats ? stats?.movie : "-", route: "/data/movie", type: _TYPES_.MOVIE },
    { name: "Getting Around", quantity: stats ? stats?.getting_around : "-", route: "/data/get/around", type: _TYPES_.GETTINGAROUND },
  ];

  const totalItems = List.reduce(
    (sum, item) => sum + (typeof item.quantity === "number" ? item.quantity : 0),
    0
  );

  return (
    <div className="h-full overflow-y-auto bg-gray-50 p-4 rounded-b-xl">
      <div className="mx-auto w-full max-w-6xl">
        <GoBack props={{ route: companiesRoute }} />

        <div className="relative mt-3 mb-5">
          <div className="pointer-events-none absolute -inset-x-6 -top-6 h-24 rounded-3xl bg-gradient-to-r from-emerald-400/15 via-amber-400/15 to-fuchsia-400/15 blur-2xl -z-10" />
          <div className="relative rounded-2xl border border-gray-200 bg-white/90 shadow-sm backdrop-blur">
            <div className="flex flex-col gap-4 p-5 md:flex-row md:items-center md:justify-between">
              <div className="flex items-center gap-3">
                <div className="grid h-10 w-10 place-items-center rounded-xl bg-gray-900 text-white text-xs font-bold shadow-sm">
                  {company_name?.slice(0, 2)?.toUpperCase() || "CO"}
                </div>
                <div className="min-w-0">
                  <DashboardIntro props={{ intro: "Company", name: company_name }} />
                </div>
              </div>

              <div className="flex flex-wrap items-center gap-2">
                <StatChip label="Content Types" value={List.length} />
                <StatChip label="Total Items" value={totalItems} tone="emerald" />
                <StatChip label="Owner" value={company_owner || "-"} />
              </div>
            </div>
          </div>
        </div>

        <div className="grid grid-cols-2 md:grid-cols-4 xl:grid-cols-8 gap-4">
          {List.map((card, index) => {
            const tones = [
              { grad: "from-emerald-500 via-teal-500 to-cyan-500" },
              { grad: "from-fuchsia-500 via-pink-500 to-rose-500" },
              { grad: "from-indigo-500 via-violet-500 to-purple-500" },
              { grad: "from-amber-500 via-orange-500 to-red-500" },
              { grad: "from-sky-500 via-blue-500 to-indigo-500" },
              { grad: "from-lime-500 via-green-500 to-emerald-500" },
            ];
            const tone = tones[index % tones.length];

            return (
              <Link
                key={`${card.name}-${index}`}
                to={card?.route}
                onClick={() => {
                  setSingleAdmin({
                    ids: [company_owner],
                    type: card?.type,
                    route: "/company/dashboard",
                  });
                }}
                className="group"
              >
                <div
                  className={`rounded-2xl p-[1px] bg-gradient-to-br ${tone.grad} shadow-sm transition-transform duration-200 group-hover:-translate-y-0.5 overflow-hidden`}
                >
                  <div className="rounded-2xl bg-white shadow-sm ring-1 ring-black/5 p-2">
                    <Card
                      card={{
                        name: card.name,
                        quantity: card.quantity,
                        icon: Icon[index],
                      }}
                    />
                  </div>
                  <div className={`h-1 bg-gradient-to-r ${tone.grad}`} />
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default CompanyDash;

const StatChip = ({ label, value, tone = "slate" }) => {
  const tones = {
    slate: "bg-gray-100 text-gray-800 ring-gray-200",
    emerald: "bg-emerald-50 text-emerald-700 ring-emerald-200",
  };
  return (
    <span
      className={[
        "inline-flex items-center gap-1.5 rounded-full px-2.5 py-1 text-[11px] font-medium ring-1",
        tones[tone] || tones.slate,
      ].join(" ")}
    >
      <span className="text-[10px] uppercase tracking-wide opacity-70">{label}:</span>
      <span className="font-semibold">{typeof value === "number" ? value : String(value)}</span>
    </span>
  );
};
